import React, { useState } from "react";
import { Card, Descriptions, Tag, Space } from "antd";
import { useStaffMinutesStore } from "../../../config/stores";
import AppButton from "../../../components/common/AppButton";
import RecordStatus from "../../../components/common/RecordStatus";
import AddRejections from "../../../components/shared/Rejections/AddRejections";
import moment from "moment";
import appConfig from '../../../config/config.json'
import { useDispatch } from "react-redux";
import { rejectionsActions } from "../../../config/actions/rejections/rejections.actions";
import RecordStatusButtons from "../../../components/common/FormStatusButtons";

const StaffMinutesDetails = () => {
    const staffMinutesStore = useStaffMinutesStore();
    const { staffMinuteDetailsRecord, setShowStaffMinuteDetails, gettingStaffMinuteDetails } = staffMinutesStore;
    const [showRejectModal, setShowRejectModal] = useState(false);

    const {
        id,
        date,
        type,
        venue,
        status,
        created_by,
        file_path,
    } = staffMinuteDetailsRecord || {};

    const handleApprove = () => {
        staffMinutesStore.approveStaffMinute(id);
    };
    const handleCheck = () => {
        staffMinutesStore.checkStaffMinute(id);
    };

    const dispatch = useDispatch();
    const reject = () => {
        dispatch(
            rejectionsActions.toggleRejectionsModal({
                visible: true,
                data: {
                    user_to_id: staffMinutesStore?.created_by_id,
                    item_application: "Staff Minutes",
                    item_id: staffMinuteDetailsRecord?.id,
                    itemName: `Staff Minutes ${staffMinuteDetailsRecord?.date}`,
                },
            })
        );
    };
    return (
        <Card
            title="Staff Minutes Details"
            extra={
                <Space>
                    <AppButton type="default" text="Reload" onClick={() => staffMinutesStore.getStaffMinuteDetails(id)} />
                    <AppButton type="default" danger text="Close" onClick={() => setShowStaffMinuteDetails(false, null)} />
                </Space>
            }
            loading={gettingStaffMinuteDetails}
        >
            <Descriptions bordered column={1} size="middle">
                <Descriptions.Item label="Date">{date ? moment(date).format("DD/MM/YYYY") : ""}</Descriptions.Item>
                <Descriptions.Item label="Type">{type}</Descriptions.Item>
                <Descriptions.Item label="Venue">{venue}</Descriptions.Item>
                <Descriptions.Item label="Status">
                    <Space>
                        <RecordStatus status={status} />
                    </Space>
                </Descriptions.Item>
                <Descriptions.Item label="Actions">
                    <RecordStatusButtons
                        hasRejection
                        data={staffMinuteDetailsRecord}
                        storeActions={{
                            approve: staffMinutesStore.approveStaffMinute,
                            approving: staffMinutesStore.approvingStaffMinute,
                            reject: reject,
                            check: staffMinutesStore.checkStaffMinute,
                            checking: staffMinutesStore.checkingStaffMinute,
                        }}
                    />
                </Descriptions.Item>
                <Descriptions.Item label="Created By">
                    {created_by ? `${created_by.first_name || ""} ${created_by.other_names || ""}` : ""}
                </Descriptions.Item>
                <Descriptions.Item label="Minutes Document">
                    {file_path ? (
                        <iframe
                            src={`${appConfig.server_url}/${file_path}`}
                            title="Staff Minutes Document"
                            width="100%"
                            height="500px"
                            style={{ border: 0 }}
                        />
                    ) : (
                        "No document uploaded."
                    )}
                </Descriptions.Item>
            </Descriptions>
            {showRejectModal && <AddRejections />}
        </Card>
    );
};

export default StaffMinutesDetails; 